import Swiper from "swiper";

class SwiperManager {
  init() {
    this.swiperContainer = document.querySelector(".swiper-container");
  }

  start() {
    this.mySwiper = new Swiper(".swiper-container", {
      slidesPerView: 3,
      watchSlidesVisibility: true,
      spaceBetween: 17,
      navigation: {
        nextEl: ".swiper-next-arrow",
        prevEl: ".swiper-prev-arrow"
      },
      breakpoints: {
        768: {
          slidesPerView: 1
        },
        1248: {
          slidesPerView: 2
        }
      }
    });
  }

  destroy() {
    if (Array.isArray(this.mySwiper)) {
      this.mySwiper.map(s => s.destroy());
    } else {
      this.mySwiper.destroy();
    }
  }
}

export default SwiperManager;



// WEBPACK FOOTER //
// ./src/managers/SwiperManager.js